import log from 'loglevel';
import React, { useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { Events } from '../../types/player';
import ControlButton from '../ui/ControlButton';

const Airplay = () => {
  const { sdk } = usePlayerContext();

  const prefix = sdk.getClassNamePrefix();

  const [airPlayAvailabilityState, setAirPlayAvailabilityState] = useState(
    sdk.hasAirPlay(),
  );

  useEffect(() => {
    sdk.on(Events.AIRPLAY_AVAILABILITY_CHANGED, (available: boolean) => {
      setAirPlayAvailabilityState(available);
    });
  }, []);

  function toggle() {
    sdk.showAirPlayTargetPicker();
  }

  console.log('airPlayAvailabilityState', airPlayAvailabilityState);

  if (!airPlayAvailabilityState) return null;

  return (
    <div
      className={`${prefix}-player-control ${sdk.getClassNamePrefix()}-player-control-airplay`}
    >
      <ControlButton
        className={'airplay'}
        icon={'airplay'}
        handleAction={toggle}
        title={'AirPlay'}
      />
    </div>
  );
};

export default Airplay;
